/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface DeploymentSpec { 
    /**
     * Availability Zone ID in given Region
     */
    availability_zone?: string;
    create_service_instance?: boolean;
    generate_dns_entry?: boolean;
    link_csp_tile?: boolean;
    /**
     * Name of deployment
     */
    name: string;
    /**
     * Org id
     */
    org_id: string;
    provider: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    region: string;
    type: ServiceTypeEnum;
    /**
     * Requested Deployment version
     */
    version?: string;
}
export namespace DeploymentSpec {
}


